import requests from '../../../../redux/reducer/requests';
import { useDispatch } from 'react-redux';

export default function useRatingCallbacks() {
  const dispatch = useDispatch();

  return {
    getGeneralWeekRating: () => {
      dispatch(requests.thunks.getWeekRating({}));
      dispatch(requests.thunks.getUserWeekRating({}));
    },
    getGeneralMonthRating: () => {
      dispatch(requests.thunks.getRating({}));
      dispatch(requests.thunks.getUserRating({}));
    },
    getGameRating: (type, { isSendGameRating = true, isSendUserGameRating = true } = {}) => {
      isSendGameRating && dispatch(requests.thunks.getGameRating({ type }));
      isSendUserGameRating && dispatch(requests.thunks.getUserGameRating({ type }));
    },
    getOldGameRating: (type, updatedAt, { isSendGameRating = true, isSendUserGameRating = true } = {}) => {
      if (isSendGameRating) dispatch(requests.thunks.getGameRating({ type, updatedAt }));
      if (isSendUserGameRating) dispatch(requests.thunks.getUserGameRating({ type, updatedAt }));
    },
    getOldWeekRating: () => dispatch(requests.thunks.getOldWeekRating()),
  };
}
